import { Answer, Product, Question, YesNoQuestion } from '@/gql/graphql';
import Fuse from 'fuse.js';

import { capitalize } from '@/core/util';

export const generateInitialValues = (questions: readonly any[]) => {
  return Object.fromEntries(
    questions.map((question) => {
      let value = '';
      // if questions are not unanswered, set the value to the answer
      if (question.answer !== Answer.Unanswered) {
        value = capitalize(question.answer);
      }
      return [question.id, value];
    }),
  );
};

export const filterRadioQuestions = (product?: Product): YesNoQuestion[] => {
  if (!product) return [];
  const radioQuestions = product.tailoringProcess.questions.filter((question) => {
    return question.__typename === 'YesNoQuestion';
  });
  return radioQuestions as YesNoQuestion[];
};

export const filterQuestionsRadio = (questions: Question[]): YesNoQuestion[] => {
  const radioQuestions = questions.filter((question) => {
    return question.__typename === 'YesNoQuestion';
  });
  return radioQuestions as YesNoQuestion[];
};

export const questionsFilter = (questions: YesNoQuestion[], filter: 'ALL' | 'ANSWERED' | 'UNANSWERED') => {
  if (filter === 'ALL') {
    return questions;
  }
  if (filter === 'ANSWERED') {
    return questions.filter((question) => {
      return question.answer === 'YES' || question.answer === 'NO';
    });
  }
  if (filter === 'UNANSWERED') {
    return questions.filter((question) => {
      return question.answer === Answer.Unanswered;
    });
  }
};

export const questionsSearch = (questions: YesNoQuestion[], search: string) => {
  const value = search;
  if (value === '') return questions;
  const fuse = new Fuse(questions, {
    includeScore: true,
    shouldSort: false,
    keys: ['question', 'relevance'],
  });
  return fuse.search(value).map((r) => r.item);
};
